import locationService from "../services/web/location-service.js";

export const getNeighborhoods = (search, callback) => {
    if (search === '') {
        callback([]);
    }

    locationService.getNeighborhoods(search)
        .then((data) => {
            callback(data.map(({label, value}) => ({value, label})));
        })
}

export const getCities = (search, callback) => {
    if (search === '') {
        callback([]);
    }

    locationService.getCities(search)
        .then((data) => {
            callback(data.map(({label, value}) => ({value, label})));
        })
}

export const getStreets = (search, callback) => {
    if (search === '') {
        callback([]);
    }

    locationService.getStreets(search)
        .then((data) => {
            callback(data.map(({label, value}) => ({value, label})));
        })
}

export const getCountries = (search, callback) => {
    if (search === '') {
        callback([]);
    }

    locationService.getCountries(search)
        .then((data) => {
            callback(data.map(({id, text}) => ({value: id, label: text})));
        })
}

let locations = [];
export const getLocations = (search, callback) => {

    if (search === '' || search === undefined) {
        callback([]);
    }

    if (locations.length === 0) {
        locationService.getLocations()
            .then(response => {
                locations = response.data;
                callback(response.data);
            })

    } else {
        locations = locations.filter(location => location.label.toUpperCase().includes(search.toUpperCase()))
        callback(locations)
    }
}

export const getLocationById = async (location) => {
    if (location) {
        const data = await locationService.getLocationById(location);

        return {
            description: data.name,
            type: data.type,
            address: data.street,
            number: data.number,
            complement: data.complement,
            neighborhood: data.neighborhood,
            city: data.city + " - " + data.state,
            latitude: data.latitude,
            longitude: data.longitude,
            contact: data.contact
        }
    }

    return {
        location: "",
        street: "",
        number: "",
        neighborhood: "",
        city: "",
        latitude: "",
        longitude: "",
        value: "",
        place: ""
    }
}

export const foundLocation = async (value) => {
    const response = await axios.get(`${projectUtils.properties.PATH}/place/getPlace/placeNames`);
    const location = response.data.find(loc => loc.value === value);
    return location ?? null;
}

export const correctLocationModel = (locationModel, camera) => {
    if(camera.city){
        locationModel.city = camera.city;
    }

    if(camera.neighborhood){
        locationModel.neighborhood = camera.neighborhood;
    }

    if(camera.street){
        locationModel.street = camera.street;
    }

    if(camera.number){
        locationModel.number = camera.number;
    }

    if(camera.latitude){
        locationModel.latitude = camera.latitude;
    }

    if(camera.longitude){
        locationModel.longitude = camera.longitude;
    }
}